<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="$emit('closeDialog')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ item.APELNOM }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="saveChecklist">{{ $t('Guardar') }}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <aru-auto-form
        v-if="config && config.form && !loading"
        v-model="formData"
        :form-configuration="config.form"
        :submit-button="false"
        :dismiss-button="false"
      ></aru-auto-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="$emit('closeDialog')">{{ $t('Cancelar') }}</v-btn>

      <v-spacer></v-spacer>

      <v-btn color="primary" @click="saveChecklist">{{ $t('Guardar') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AruAutoForm from '@/components/commons/form/AruAutoForm';
import ApiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  components: {
    AruAutoForm,
  },
  props: {
    config: {
      type: Object,
    },
    clavedat: {
      type: [String, Number],
    },
    item: {
      type: [Object],
    },
  },
  data() {
    return {
      formData: {},
      loading: false,
    };
  },
  mounted() {
    this.loading = true;
    const checklist =
      this.item && this.item.customer_checklist && this.item.customer_checklist.checklist
        ? this.item.customer_checklist.checklist
        : {};
    // if(checklist) {
    //     for (const key in checklist) {
    //         if  (checklist.hasOwnProperty(key)) {
    //             const value = checklist[key];
    //             this.$set(this.formData, key, value);
    //         }
    //     }
    // }
    this.formData = checklist;
    this.loading = false;
    console.log('Item from CustomerChecklist', this.item);
  },
  methods: {
    saveChecklist() {
      console.log('Item from CustomerChecklist SAVE', this.item);
      ApiCtrl.post('/customer-checklist/clavedat/' + this.clavedat, this.formData).then(res => {
        console.log('saveChecklist Res', res);
        this.$emit('closeDialog');
        this.$emit('checklistSaved');
      });
    },
  },
  computed: {},
  watch: {
    //data: (val, oldVal) => {
    //},
  },
};
</script>

<style lang="scss"></style>
